import { Controller } from "@hotwired/stimulus";
import tippy from "tippy.js";

export default class extends Controller {
  static targets = ["phone", "email"];

  connect() { }

  revealPhone() {
    this.revealContactInfo("phone", "reveal_phone");
  }

  revealEmail() {
    this.revealContactInfo("email", "reveal_email");
  }

  revealContactInfo(contactType, endpoint) {
    const targetElement = this[`${contactType}Target`];
    if (targetElement.disabled) {
      event.preventDefault();
      return;
    }

    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute("content");
    const annonceId = targetElement.dataset.annonceId;
    const url = `/remplacements/${annonceId}/${endpoint}`; // ← CHANGED THIS LINE

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        if (data.phone) {
          targetElement.textContent = data.phone;
          targetElement.dataset.phoneNumber = data.phone;
          targetElement.removeEventListener("click", this.revealPhone);
          targetElement.addEventListener("click", () => {
            window.location.href = `tel:${targetElement.dataset.phoneNumber}`;
          });
          this.applyTippy(this.phoneTarget, "Cliquez pour appeler");
        }
        if (data.email) {
          targetElement.textContent = data.email;
          targetElement.dataset.emailAddress = data.email;
          targetElement.removeEventListener("click", this.revealEmail);
          targetElement.addEventListener("click", () => {
            window.location.href = `mailto:${targetElement.dataset.emailAddress}`;
          });
          this.applyTippy(this.emailTarget, "Cliquez pour envoyer un email");
        }
      })
      .catch((error) => console.error("Error:", error));
  }

  applyTippy(target, content) {
    tippy(target, {
      content: content,
      allowHTML: true,
      theme: "mydefault",
      maxWidth: "210px",
      minWidth: "0px",
      placement: "bottom",
    }).show();
  }
}